const NotFound = () => {
    return (
        <div className="input-outer reg-container">
            <div className="row">
                <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 col-xxs-12">
                    <div className="text-content">
                        <h2>NotFound Component</h2>
                    </div>
                </div>
                <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12 col-xxs-12">
                    <h2>NotFound Component</h2>
                </div>
            </div>
        </div>
    )
};

export default NotFound